import React from 'react';
import { Terminal, Github, Linkedin } from 'lucide-react';
import { personalInfo } from '../mock';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer style={{
      background: '#000000',
      borderTop: '1px solid rgba(0, 255, 209, 0.3)',
      padding: '80px 7.6923% 40px',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Main footer content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '60px',
          marginBottom: '60px'
        }}>
          {/* Brand section */}
          <div>
            <div style={{
              fontFamily: 'monospace',
              fontSize: '24px',
              fontWeight: 700,
              color: '#00FFD1',
              marginBottom: '16px',
              textShadow: '0 0 10px rgba(0, 255, 209, 0.5)'
            }}>
              {'<GOLDHAT />'}
            </div>
            <p style={{
              fontSize: '14px',
              lineHeight: 1.7,
              color: 'rgba(255, 255, 255, 0.7)',
              fontFamily: 'monospace',
              marginBottom: '24px'
            }}>
              DevOps Engineer | AI Systems Architect | Digital Warfare Specialist
            </p>
            <div style={{
              display: 'flex',
              gap: '16px'
            }}>
              <a
                href={personalInfo.github}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: '40px',
                  height: '40px',
                  border: '1px solid rgba(0, 255, 209, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#00FFD1',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#00FFD1';
                  e.currentTarget.style.color = '#000000';
                  e.currentTarget.style.borderColor = '#00FFD1';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#00FFD1';
                  e.currentTarget.style.borderColor = 'rgba(0, 255, 209, 0.3)';
                }}
              >
                <Github size={20} />
              </a>
              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: '40px',
                  height: '40px',
                  border: '1px solid rgba(0, 255, 209, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#00FFD1',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#00FFD1';
                  e.currentTarget.style.color = '#000000';
                  e.currentTarget.style.borderColor = '#00FFD1';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#00FFD1';
                  e.currentTarget.style.borderColor = 'rgba(0, 255, 209, 0.3)';
                }}
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '20px',
              fontFamily: 'monospace',
              letterSpacing: '1px'
            }}>
              QUICK ACCESS
            </h3>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              {[
                { label: './about', id: 'about' },
                { label: './skills', id: 'skills' },
                { label: './projects', id: 'projects' },
                { label: './timeline', id: 'timeline' },
                { label: './contact', id: 'contact' }
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: '14px',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontFamily: 'monospace',
                    transition: 'all 0.3s ease',
                    padding: '4px 0'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#00FFD1';
                    e.currentTarget.style.paddingLeft = '8px';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)';
                    e.currentTarget.style.paddingLeft = '0';
                  }}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Projects */}
          <div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '20px',
              fontFamily: 'monospace',
              letterSpacing: '1px'
            }}>
              FEATURED MISSIONS
            </h3>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              {[
                'ShadowMind Terminal',
                'OpsMind AI Assistant',
                'WarMind Recon Engine',
                'Cloud Migrations'
              ].map((project, index) => (
                <div
                  key={index}
                  style={{
                    fontSize: '14px',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontFamily: 'monospace',
                    padding: '4px 0',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#00FFD1';
                    e.currentTarget.style.paddingLeft = '8px';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)';
                    e.currentTarget.style.paddingLeft = '0';
                  }}
                >
                  <span style={{ marginRight: '8px', color: '#00FFD1' }}>{'>'}</span>
                  {project}
                </div>
              ))}
            </div>
          </div>

          {/* Status */}
          <div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '20px',
              fontFamily: 'monospace',
              letterSpacing: '1px'
            }}>
              SYSTEM STATUS
            </h3>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div style={{
                  width: '8px',
                  height: '8px',
                  background: '#00FFD1',
                  boxShadow: '0 0 10px rgba(0, 255, 209, 0.8)',
                  animation: 'pulse 2s infinite'
                }} />
                <span style={{
                  fontSize: '14px',
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontFamily: 'monospace'
                }}>
                  STATUS: ONLINE
                </span>
              </div>
              <div style={{
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.7)',
                fontFamily: 'monospace',
                lineHeight: 1.6
              }}>
                <div>UPTIME: 99.9%</div>
                <div>LOCATION: {personalInfo.location}</div>
                <div>CLEARANCE: {personalInfo.clearance}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          paddingTop: '40px',
          borderTop: '1px solid rgba(0, 255, 209, 0.2)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <div style={{
            fontSize: '14px',
            color: 'rgba(255, 255, 255, 0.5)',
            fontFamily: 'monospace'
          }}>
            © {new Date().getFullYear()} {personalInfo.alias}. All systems operational.
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '12px',
            color: 'rgba(255, 255, 255, 0.5)',
            fontFamily: 'monospace'
          }}>
            <Terminal size={14} style={{ color: '#00FFD1' }} />
            <span>Built with React + FastAPI + MongoDB</span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.2);
          }
        }

        @media (max-width: 768px) {
          footer > div > div:first-child {
            grid-template-columns: 1fr !important;
          }
          footer > div > div:last-child {
            flex-direction: column !important;
            text-align: center !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;